import React, { useState, useEffect } from 'react';
import { View, Dimensions } from 'react-native';
import { connect } from 'react-redux';

import { isWeb, timePeriod, ALL_MACHINES, isPhone, addQueryParams, removeQueryParam, localTime, chartStatuses, parseRouteParamAsNumber } from '@helpers';
import { width, Element, scale } from '@components/frame';

import {
  getMachines,
  getMachineStatistics,
  updateMachineInfo,
  clearMachines,
  setNCFileStatistics,
  setMachineStatistics,
  setSelectedNCFile as setSelectedNCFileMachines,
  getNCFileStatistics,
} from '../../reducers/machines';
import { updateDevice } from '@reducers/device';
import { removeProductionInformation, setSelectedNCFile as setSelectedNCFileManufacture } from '@reducers/manufacture';
import { generateImageURL, generateNCFileURL } from '@reducers/blobStorage';
import { getTimeSetup } from '@reducers/time';
import { getConnectorInfo } from '@reducers/connector';
import { acquireEntityDetailsFromReplica, getErpFields } from '@reducers/erp';
import { setGlobalSelectedLevel } from '@reducers/globalAdd';

import ColorWrapper from '@styles/colors';

import List from './components/list';
import Details from './components/details';
import NCFilesActionsModal from './components/header/components/modals/actionsModal';
import { useHandleParams } from '@v2/pages/machines/hooks/useHandleParams';

let interval;

const MODES = {
  FULL: 'FULL',
  LIST: 'LIST',
  DETAILS: 'DETAILS',
};

const Machines = ({
  setSelectedNCFileMachines,
  setSelectedNCFileManufacture,
  machines: { machineStatisticsForNCFile, ncFileStatistics, selectedNCFileItem, selectedItem: selectedMachine },
  manufacture: { selectedNCFile },
  navigation,
  C,
  updateAppValue,
  mode,
  onBack,
  route,
  lg,
  generateImageURL,
  generateNCFileURL,
  getNCFileStatistics,
  acquireEntityDetailsFromReplica,
  getErpFields,
  user,
  setGlobalSelectedLevel,
}) => {
  const {id} = useHandleParams();
  const isManufacture = route?.params?.manufacture && route?.params?.manufacture !== 'false';
  const ncFileName = route?.params?.ncFile;
  const panelViewMode = isManufacture;
  const selectedItem = isManufacture ? selectedNCFile : selectedNCFileItem;
  const setSelectedNCFileInternal = isManufacture ? setSelectedNCFileManufacture : setSelectedNCFileMachines;
  const setSelectedNCFile = (data, ignoreHistory) => {
    if (!ignoreHistory) {
      if (data.machineStatus.ncFile) {
        addQueryParams({ ncFile: data.machineStatus.ncFile });
      } else {
        removeQueryParam('ncFile');
      }
    }
    setSelectedNCFileInternal(data);
  };

  const initialTime = route?.params?.section || timePeriod.PROPERTIES;

  const d = route?.params?.date;

  const initialChartDate = d && d != 'null' ? localTime(d).format() : null;

  const [modalMissingPIOpen, setModalMissingPIOpen] = useState(false);
  const [isRemovingPI, setIsRemovingPI] = useState(false);

  const isGlobalMachineList = mode === MODES.LIST && isPhone;
  const allSelected = selectedItem?.ncFileId === ALL_MACHINES || isGlobalMachineList;

  const [selectedTime, setSelectedTimeLocalInternal] = useState(
    isPhone ? initialTime : allSelected && initialTime === timePeriod.NOW ? timePeriod.PROPERTIES : initialTime
  );

  const setSelectedTimeLocal = (data) => {
    if (data) {
      addQueryParams({ section: data });
    } else {
      removeQueryParam('section');
    }
    setSelectedTimeLocalInternal(data);
  };

  const [chartData, setChartData] = useState({});
  const [selectedChartDate, setSelectedChartDateInternal] = useState(initialChartDate);
  const setSelectedChartDate = (data) => {
    if (data) {
      addQueryParams({ date: localTime(data).format('YYYY-MM-DD') });
    } else {
      removeQueryParam('date');
    }
    setSelectedChartDateInternal(data);
  };
  const [selectedPeriod, setSelectedPeriodInternal] = useState(chartStatuses[String(route?.params?.status).toLocaleLowerCase()] || 'Productive');

  const setSelectedPeriod = (data) => {
    addQueryParams({ status: data });
    setSelectedPeriodInternal(data);
  };

  const initialLevel = route?.params?.level || 'ncFile';
  const ncFileId = parseRouteParamAsNumber(route?.params?.ncFileId);

  const [selectedLevel, setSelectedLevel] = useState(initialLevel);
  const [selectedNCFileLevel, setSelectedNCFileLevel] = useState('general');
  const [actionsModalOpen, setActionsModalOpen] = useState(false);

  const setSelectedTime = (t) => {
    setChartData({});
    setSelectedTimeLocal(t);
  };

  const listWidth = scale(360);
  const detailsWidth = width - scale(360);

  useEffect(() => {
    setGlobalSelectedLevel(selectedLevel);
  }, [selectedLevel]);

  useEffect(() => {
    setGlobalSelectedLevel(selectedLevel);
    if (mode === MODES.DETAILS) {
      return;
    }
    (async () => {
      const getItems = async ({ reset }) => {
        const d = { period: route?.params?.period, date: selectedChartDate, machineId: id, reset };
        if (ALL_MACHINES == id) {
          delete d.machineId;
        }
        const data = await getNCFileStatistics(d);

        const exist = data.machineStatistics.find((i) => i.ncFileName == ncFileName);

        const isMore = data.machineStatistics.length === ncFileStatistics.count;
        if (exist) {
          return exist;
        }

        if (isMore && !exist) {
          return await getItems({ reset: false });
        }
      };

      const exist = ncFileStatistics?.data?.find((i) => i.ncFileName == ncFileName);
      if (!exist) {
        const item = await getItems({ reset: true });
        setSelectedNCFile({
          machineStatus: {
            ...item,
            ncFile: item?.ncFileName,
          },
        });
        return;
      }

      if (selectedNCFileItem?.machineStatus?.ncFile !== exist.ncFileName) {
        setSelectedNCFile({
          machineStatus: {
            ...exist,
            ncFile: exist?.ncFileName,
          },
        });
      }
    })();
  }, []);
  const detailsProps = {
    selectedTime,
    setSelectedTime,
    setModalMissingPIOpen,
    updateAppValue,
    navigation,
    detailsWidth,
    isRemovingPI,
    modalMissingPIOpen,
    panelViewMode,
    route,
    highlightHeader: route?.params?.highlightHeader,
    lg,
    selectedChartDate,
    setSelectedChartDate,
    onBack,
    selectedPeriod,
    setSelectedPeriod,
    chartData,
    setChartData,
    selectedLevel,
    setSelectedLevel,
    selectedNCFileLevel,
    setSelectedNCFileLevel,
    ncFileId,
    setSelectedNCFile,
    selectedItem,
    isManufacture,
    setActionsModalOpen,
  };

  const listProps = {
    data: ncFileStatistics.data,
    ncFileStatistics,
    setSelectedNCFile,
    navigation,
    updateAppValue,
    listWidth,
    selectedTime,
    setSelectedTime,
    generateImageURL,
    selectedPeriod,
    machineStatisticsForNCFile,
    selectedItem,
    selectedMachine,
  };

  const renderComponent = () => {
    switch (mode) {
      case MODES.DETAILS: {
        return <Details {...detailsProps} />;
      }
      case MODES.LIST: {
        return isPhone && selectedTime !== timePeriod.NOW ? <Details {...{ ...detailsProps, isGlobalMachineList }} /> : <List {...listProps} />;
      }
      case MODES.FULL: {
        return [<List key="ListComponent" {...listProps} />, <Details key="DetailsComponent" {...detailsProps} />];
      }
    }
  };

  return [
    <View
      key="machineDetailsBlock"
      style={[
        {
          height: '100%',
          backgroundColor: C('Background/Light/Detail'),
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
          flex: 1,
        },
      ]}
    >
      {isWeb && (
        <Element
          {...{
            config: {
              backgroundColor: C(mode === MODES.DETAILS ? 'Background/Light/Detail' : 'Background/Light/System'),
              position: { top: 0, bottom: 0, left: 0 },
              width: (Dimensions.get('window').width - width) / 1.9,
            },
          }}
        />
      )}
      <View style={{ width: '100%', flex: 1 }}>
        <View style={{ flexDirection: 'row', flex: 1 }}>{renderComponent()}</View>
      </View>
      {actionsModalOpen && (
        <NCFilesActionsModal
          {...{
            C,
            panelViewMode,
            selectedLevel,
            setActionsModalOpen,
            selectedItem,
            acquireEntityDetailsFromReplica,
            route,
            getErpFields,
            ncFileId: selectedItem?.machineStatus?.ncFileId,
            user,
            generateNCFileURL,
          }}
          key="NCFilesActionsModal"
        />
      )}
    </View>,
  ];
};

const mapStateToProps = ({ user, machines, time, connector, manufacture }) => ({ user, machines, time, connector, manufacture });

export default connect(mapStateToProps, {
  getMachines,
  setSelectedNCFileMachines,
  setSelectedNCFileManufacture,
  updateMachineInfo,
  updateDevice,
  removeProductionInformation,
  clearMachines,
  generateImageURL,
  generateNCFileURL,
  getTimeSetup,
  getConnectorInfo,
  getMachineStatistics,
  setNCFileStatistics,
  setMachineStatistics,
  getNCFileStatistics,
  acquireEntityDetailsFromReplica,
  getErpFields,
  setGlobalSelectedLevel,
})(ColorWrapper(Machines));
